import { render, staticRenderFns } from "./EmployeeAddressList.vue?vue&type=template&id=2d81db32&"
import script from "./EmployeeAddressList.vue?vue&type=script&lang=js&"
export * from "./EmployeeAddressList.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAddressList.vue?vue&type=style&index=0&id=2d81db32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports